import React, { useState } from "react";
import axios from "axios";
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';

const timeSlotOptions = [
  "9:00 AM - 10:00 AM",
  "10:00 AM - 11:00 AM",
  "11:00 AM - 12:00 PM",
  "1:00 PM - 2:00 PM",
  "2:00 PM - 3:00 PM",
];

const FullScreenLoader = () => {
  return (
    <section className="fixed z-[1000] top-0 left-0 right-0 bottom-0 bg-black bg-opacity-30 grid place-content-center">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="120px"
        height="120px"
        className="h-24 w-24 "
        viewBox="0 0 100 100"
        preserveAspectRatio="xMidYMid"
      >
        <circle
          cx="50"
          cy="50"
          fill="none"
          stroke="#24B354"
          strokeWidth="10"
          r="35"
          strokeDasharray="164.93361431346415 56.97787143782138"
        >
          <animateTransform
            attributeName="transform"
            type="rotate"
            repeatCount="indefinite"
            dur="1s"
            values="0 50 50;360 50 50"
            keyTimes="0;1"
          ></animateTransform>
        </circle>
      </svg>
    </section>
  );
};

const DemoForm = () => {
  const [step, setStep] = useState(1);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    organization: "",
    notes: "",
    date: "",
    timeSlots: [],
  });
  const [errors, setErrors] = useState({});
  const [submitted, setSubmitted] = useState(false);
  const [submittedErr, setSubmittedErr] = useState(false);
  const [isLoading, setLoading] = useState(false);

  const validateStep1 = () => {
    const errs = {};
    if (!formData.name.trim()) errs.name = "Name is required";
    if (!formData.email.trim()) errs.email = "Email is required";
    else if (!/\S+@\S+\.\S+/.test(formData.email)) errs.email = "Invalid email";
    if (!formData.phone.trim()) errs.phone = "Phone is required";
    else if (!/^\d{6,15}$/.test(formData.phone)) errs.phone = "Phone number should be more than 8 digits.";
    if (!formData.organization.trim()) errs.organization = "Organization required";
    if (!formData.notes.trim()) errs.notes = "Message is required";
    return errs;
  };

  const validateStep2 = () => {
    const errs = {};
    if (!formData.date) errs.date = "Date is required";
    if (formData.timeSlots.length !== 2) errs.timeSlots = "Select any 2 slots";
    return errs;
  };

  const getTomorrowDate = () => {
    const tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate() + 1);
    return tomorrow.toISOString().split("T")[0]; // Format as YYYY-MM-DD
  };

  const minDate = getTomorrowDate();
  const handleChangeDate = (e) => {
    const { name, value } = e.target;

    if (name === "date") {
      const selectedDate = new Date(value);
      const day = selectedDate.getDay(); // 0 = Sunday, 6 = Saturday

      if (day === 0 || day === 6) {
        setErrors((prev) => ({ ...prev, date: "Weekends are not allowed" }));
        return;
      }
    }

    setFormData((prev) => ({ ...prev, [name]: value }));
    setErrors((prev) => ({ ...prev, [name]: "" }));
  };


  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    setErrors((prev) => ({ ...prev, [name]: "" }));
  };

  const handleTimeSlotChange = (slot) => {
    setFormData((prev) => {
      const slots = prev.timeSlots.includes(slot)
        ? prev.timeSlots.filter((s) => s !== slot)
        : [...prev.timeSlots, slot];
      return { ...prev, timeSlots: slots };
    });
    setErrors((prev) => ({ ...prev, timeSlots: "" }));
  };

  const handleNext = () => {
    const errs = validateStep1();
    if (Object.keys(errs).length === 0) setStep(2);
    else setErrors(errs);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const errs = validateStep2();
    if (Object.keys(errs).length === 0) {
      setLoading(true);
      try {
        await axios.post("https://mailservice.verdemobility.com/api/Email/schedule-form", formData);
        setSubmitted(true)
      } catch (err) {
        console.log(err)
        setSubmittedErr(true)
      } finally {
        setLoading(false);
      }
    } else {
      setErrors(errs);
    }
  };
  if (submitted)
    return (
      <div className="text-center p-6 text-xl text-green-600">
        Thank you! Your response has been recorded.
      </div>
    );

  return (
    <div className="h-[90%] bg-black flex justify-center items-center p-4 rounded">
      {isLoading ? <FullScreenLoader /> : ''}
      <form
        onSubmit={handleSubmit}
        className="w-full max-w-2xl bg-black text-white p-6 rounded-lg space-y-6"
      >
        {/* <h2 className="text-xl font-semibold mb-4">Step {step} of 2</h2> */}

        {step === 1 && (
          <>
            {/* Name */}
            <div>
              <input
                type="text"
                name="name"
                placeholder="Full Name"
                value={formData.name}
                onChange={handleChange}
                className="w-full p-3 rounded bg-[#2d2d2d] border-b-2 border-green-500 placeholder-gray-400 focus:outline-none font-poppinss"
              />
              {errors.name && <p className="text-red-400 text-sm">{errors.name}</p>}
            </div>

            {/* Email & Phone */}
            <div className="flex flex-col sm:flex-row gap-4">
              <div className="flex-1">
                <input
                  type="email"
                  name="email"
                  placeholder="Email Address"
                  value={formData.email}
                  onChange={handleChange}
                  className="w-full p-3 rounded bg-[#2d2d2d] border-b-2 border-green-500 placeholder-gray-400 focus:outline-none font-poppinss"
                />
                {errors.email && <p className="text-red-400 text-sm">{errors.email}</p>}
              </div>
              <div className="flex-1 demoForm">
                {/* <input
                  type="text"
                  name="phone"
                  placeholder="+91 XXXXX XXXXX"
                  value={formData.phone}
                  onChange={handleChange}
                  className="w-full p-3 rounded bg-[#2d2d2d] border-b-2 border-green-500 placeholder-gray-400 focus:outline-none font-poppinss"
                /> */}
                <PhoneInput
                  country={'us'}
                  value={formData.phone}
                  onChange={(value, country) => {
                    setFormData({
                      ...formData,
                      phone: value, // value already contains the full international number
                      dialCode: country?.dialCode || '',
                    });
                  }}
                  inputProps={{
                    name: 'phone',
                    required: true,
                  }}
                  containerClass="w-full"
                  inputClass="w-full p-3 pl-11 !h-[52px] rounded !bg-[#2d2d2d] border-b-2 border-green-500 focus:outline-none font-poppinss"
                />
                {errors.phone && <p className="text-red-400 text-sm">{errors.phone}</p>}
              </div>
            </div>

            {/* Organization */}
            <div>
              <input
                type="text"
                name="organization"
                placeholder="Organization"
                value={formData.organization}
                onChange={handleChange}
                className="w-full p-3 rounded bg-[#2d2d2d] border-b-2 border-green-500 placeholder-gray-400 focus:outline-none font-poppinss"
              />
              {errors.organization && (
                <p className="text-red-400 text-sm">{errors.organization}</p>
              )}
            </div>

            {/* Message */}
            <div>
              <textarea
                name="notes"
                placeholder="Message"
                rows={4}
                value={formData.notes}
                onChange={handleChange}
                className="w-full p-3 rounded bg-[#2d2d2d] border-b-2 border-green-500 placeholder-gray-400 focus:outline-none font-poppinss"
              />
              {errors.notes && (
                <p className="text-red-400 text-sm">{errors.notes}</p>
              )}
            </div>
            <div className="w-full flex justify-end">
              <button
                type="button"
                onClick={handleNext}
                className="bg-green hover:bg-green-700 py-2 rounded text-white font-semibold px-6"
              >
                Next
              </button>
            </div>
          </>
        )}

        {step === 2 && (
          <>
            {/* Date */}
            <div>
              {/* <input
                type="date"
                name="date"
                value={formData.date}
                onChange={handleChange}
                className="w-full p-3 rounded bg-[#2d2d2d] border-b-2 border-green-500 placeholder-gray-400 text-white focus:outline-none"
                style={{
                  WebkitAppearance: "none",
                  colorScheme: "dark",
                }}
              /> */}

              <input
                type="date"
                name="date"
                value={formData.date}
                min={minDate}
                onChange={handleChangeDate}
                className="w-full p-3 rounded bg-[#2d2d2d] border-b-2 border-green-500 placeholder-gray-400 text-white focus:outline-none"
                style={{
                  WebkitAppearance: "none",
                  colorScheme: "dark",
                }}
              />

              {errors.date && <p className="text-red-400 text-sm">{errors.date}</p>}
            </div>

            {/* Time Slots */}
            <div>
              <p className="mb-2 text-base">Select exactly 2 Time Slots</p>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                {timeSlotOptions.map((slot) => (
                  <label key={slot} className="flex items-center gap-2">
                    <input
                      type="checkbox"
                      checked={formData.timeSlots.includes(slot)}
                      onChange={() => handleTimeSlotChange(slot)}
                      className="form-checkbox text-green-500"
                    />
                    <span>{slot}</span>
                  </label>
                ))}
              </div>
              {errors.timeSlots && (
                <p className="text-red-400 text-sm mt-1">{errors.timeSlots}</p>
              )}
            </div>

            {submittedErr && (
              <p className="text-red-400 text-lg mt-1">Something went wrong please try again later!</p>
            )}

            <div className="flex justify-between">
              <button
                type="button"
                onClick={() => setStep(1)}
                className="bg-gray-700 hover:bg-gray-800 px-4 py-2 rounded"
              >
                Back
              </button>
              <button
                type="submit"
                className="bg-green hover:bg-green-700 px-6 py-2 rounded font-semibold"
              >
                Submit
              </button>
            </div>
          </>
        )}
      </form>
    </div>
  );
};

export default DemoForm;
